import Icon from '../../../../../../../components/Icon'
import { useLocation } from "react-router-dom";
import Link from '../../../../../../../components/Link'
import { connect } from 'react-redux';
import { CategoryDto } from '../../../../../../../types/category';
import { Group } from '../../../../../../../types';
import { useWindowSize } from '../../../../../../../hooks/useWindowSize';
import arrowForwardRight from '../../../../../../../assets/icons/arrow-foward.svg'

type CustomCategoryDto = Omit<CategoryDto, 'id'> & { id: number | 'without_category' };

interface ComponentProps {
  group: Group;
  groupStates: {
    loading: boolean;
    success: boolean;
    error: string | boolean;
  };
  category: CustomCategoryDto
  onClick: () => void
}

const Component = ({
  group,
  category,
  onClick
}: ComponentProps) => {
  const { isMobile } = useWindowSize()
  const location = useLocation()

  return (
    <Link
      onClick={onClick}
      options={{
        type: 'outline',
        size: 'lg',
        skin: 'black'
      }}
      style={{ borderRadius: 30, gap: 8 }}
      href={`/group/${group?.slug}/library`}
    >
      Ver todas las categorias
      <Icon icon={arrowForwardRight} size={isMobile ? "14px" : "22px"} color="black" />
    </Link>
  )
}


const state = ({ groupStore }) => {
  const { data: group, states: groupStates } = groupStore.group;

  return {
    group,
    groupStates,
  };
};

export default connect(state)(Component);